import { Permissions } from '../client_auth/permissions'

schoolTable.$inject = ['filterFilter', 'orderByFilter', 'auth', 'domainInfo', '$uibModal']

export default function schoolTable(filterFilter, orderByFilter, auth, domainInfo, $modal) {
  return {
    restrict: 'EA',
    scope: {
      schools: '=schoolTable',
      loading: '=',
      schoolAdmins: '=',
      users: '=',
      hasUserOpsPermission: '='
    },
    link: function(scope, elm, attrs) {
      scope.search = ''
      scope.orderKey = 'name'
      scope.reverse = false
      scope.sort = function(key) {
        if (scope.orderKey === key) {
          scope.reverse = !scope.reverse
        } else {
          scope.reverse = false
        }
        scope.orderKey = key
      }

      scope.$watchCollection('schools', function() {
        refreshResults()
      })

      scope.$watch('search', function(search) {
        // scope.search = search;
        refreshResults()
      })
      scope.$watch('orderKey', function(key) {
        // scope.orderKey = key;
        refreshResults()
      })
      scope.$watch('reverse', function(rev) {
        // scope.reverse = rev;
        refreshResults()
      })

      function refreshResults() {
        scope.filteredSchools = filterFilter(scope.schools, scope.search)
        scope.filteredSchools = orderByFilter(scope.filteredSchools, scope.orderKey, scope.reverse)
      }

      refreshResults()

      // editing
      scope.editSchool = function(s) {
        function onSchoolUpdated(updatedSchool) {
          s.name = updatedSchool.name
        }

        var modalInstance = $modal.open({
          scope: scope,
          controller: [
            '$uibModalInstance',
            'school',
            function($modalInstance, school) {
              this.school = school
              this.onSchoolUpdated = function(s) {
                $modalInstance.close(s)
              }
              this.close = function() {
                $modalInstance.dismiss()
              }
            }
          ],
          controllerAs: 'ctrl',
          resolve: {
            school: function() {
              return s
            }
          },
          template:
            '' +
            '<div class="modal-header"><a class="close" ng-click="ctrl.close()">&times;</a>Edit School</div>' +
            '<div class="modal-body">' +
            '<div edit-school-entity school="ctrl.school" on-school-updated="ctrl.onSchoolUpdated(school)"></div>' +
            '</div>'
        })
        modalInstance.result.then(onSchoolUpdated)
      }

      scope.manageAdmins = function(s, admins) {
        var modalInstance = $modal.open({
          scope: scope,
          controller: [
            '$uibModalInstance',
            'school',
            'admins',
            'users',
            function($modalInstance, school, admins, users) {
              this.school = school
              this.admins = admins
              this.users = users

              this.close = function() {
                $modalInstance.dismiss()
              }
            }
          ],
          controllerAs: 'ctrl',
          resolve: {
            school: function() {
              return s
            },
            admins: function() {
              return admins
            },
            users: function() {
              return scope.users
            }
          },
          template:
            '' +
            '<div class="modal-header"><a class="close" ng-click="ctrl.close()">&times;</a>Manage School Admins</div>' +
            '<div class="modal-body">' +
            '<h3 class="modal-title">{{ctrl.school.name}}</h3>' +
            '<div manage-admins type="school" entity="ctrl.school" admins="ctrl.admins" users="ctrl.users"></div>' +
            '</div>'
        })
        modalInstance.result.then(function(admins) {})
      }

      scope.deleteSchool = async function(s) {
        const hasPermission = await auth.doesUserHavePermission([Permissions.UserOps])
        if (!hasPermission) {
          alert('You do not have permission')
          return
        }
        if (confirm('Are you sure you want to delete ' + s.name + '? This action cannot be undone.')) {
          try {
            let result = await domainInfo.deleteEntity(s.uuid)
            if (result) {
              domainInfo.refreshSchools()
            }
          } catch (err) {
            alert(`There was an error deleting the school: ${err.message}`)
          }
        }
      }
    },
    template: require('./_schoolTable.html')
  }
}
